// Menu Item Types
export const MENU_ITEM_TYPES = {
    StandardDrink: 'StandardDrink',
    CustomDrink: 'CustomDrink',
    Product: 'Product',
} as const;
export type MenuItemType =
    (typeof MENU_ITEM_TYPES)[keyof typeof MENU_ITEM_TYPES];

// Menu Item availability rule types
export const AVAILABILITY_RULE_TYPES = {
    DayOfWeek: 'DayOfWeek',
    TimeOfDay: 'TimeOfDay',
    Date: 'Date',
    Season: 'Season',
} as const;
export type AvailabilityRuleType =
    (typeof AVAILABILITY_RULE_TYPES)[keyof typeof AVAILABILITY_RULE_TYPES];
